import React,{Component} from "react";

class WinnerPrize extends Component{
    render() {
        const {prizeName} = this.props;
        return (
            <>
                <div className="text bgGreen">
                    <p className="wh up fs1_5">{prizeName}</p>
                </div>
            </>
        );
    }
}
export default WinnerPrize;